import { render, staticRenderFns } from "./AssignmentsStatsTable.component.vue?vue&type=template&id=7a585d76&scoped=true&"
import script from "./AssignmentsStatsTable.component.vue?vue&type=script&lang=js&"
export * from "./AssignmentsStatsTable.component.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsStatsTable.component.vue?vue&type=style&index=0&id=7a585d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a585d76",
  null
  
)

export default component.exports